import { z } from 'zod';

export const wasteLogSchema = z.object({
  wasteId: z.string(),
  siteId: z.string(),
  venueId: z.string(),
  venueName: z.string(),
  itemId: z.string(),
  itemName: z.string(),
  type: z.enum(['pre-consumer', 'post-consumer']),
  reason: z.enum(['spoilage', 'overproduction', 'prep-waste', 'plate-waste', 'expired', 'quality-issue', 'other']),
  quantity: z.number(),
  unit: z.string(),
  estimatedCost: z.number(),
  loggedBy: z.string(),
  loggedByName: z.string(),
  notes: z.string().optional(),
  createdAt: z.string(),
});

export type WasteLog = z.infer<typeof wasteLogSchema>;
export type WasteType = WasteLog['type'];
export type WasteReason = WasteLog['reason'];

export const wasteLogsResponseSchema = z.object({
  data: z.array(wasteLogSchema),
  pagination: z.object({
    nextToken: z.string().nullable(),
    totalCount: z.number() 
  }),
  meta: z.object({
    siteId: z.string(),
    totalCost: z.number() 
  }),
});

export type WasteLogsResponse = z.infer<typeof wasteLogsResponseSchema>;

export const WASTE_TYPE_LABELS: Record<WasteType, string> = {
  'pre-consumer': 'Pre-Consumer',
  'post-consumer': 'Post-Consumer' 
};
export const WASTE_REASON_LABELS: Record<WasteReason, string> = {
  spoilage: 'Spoilage',
  overproduction: 'Overproduction',
  'prep-waste': 'Prep Waste',
  'plate-waste': 'Plate Waste',
  expired: 'Expired',
  'quality-issue': 'Quality Issue',
  other: 'Other',
};
export const WASTE_REASON_COLORS: Record<WasteReason, string> = {
  spoilage: 'bg-red-100 text-red-800',
  overproduction: 'bg-amber-100 text-amber-800',
  'prep-waste': 'bg-blue-100 text-blue-800',
  'plate-waste': 'bg-purple-100 text-purple-800',
  expired: 'bg-gray-100 text-gray-800',
  'quality-issue': 'bg-orange-100 text-orange-800',
  other: 'bg-gray-100 text-gray-800',
};
